var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandvich(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88 9.76H25.88C26.36 9.76 26.76 9.37 26.76 8.88C26.76 8.39001 26.37 8 25.88 8H5.88C5.39999 8 5 8.39001 5 8.88C5 9.37 5.39001 9.76 5.88 9.76Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.88 14.64H5.88C5.39999 14.64 5 15.03 5 15.52C5 16.01 5.39001 16.4 5.88 16.4H25.88C26.36 16.4 26.76 16.01 26.76 15.52C26.76 15.03 26.37 14.64 25.88 14.64Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88 21.26H25.88C26.37 21.26 26.76 21.65 26.76 22.14C26.76 22.63 26.36 23.02 25.88 23.02H5.88C5.39001 23.02 5 22.63 5 22.14C5 21.65 5.39999 21.26 5.88 21.26Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandvich);
export default __webpack_public_path__ + "static/media/Sandvich.3e01e8c0cba6387a2b70361c46429a22.svg";
export { ForwardRef as ReactComponent };